import { render, staticRenderFns } from "./HomeCommon.vue?vue&type=template&id=5c5cad8e&scoped=true"
import script from "./HomeCommon.vue?vue&type=script&lang=js"
export * from "./HomeCommon.vue?vue&type=script&lang=js"
import style0 from "./HomeCommon.vue?vue&type=style&index=0&id=5c5cad8e&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5cad8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5cad8e')) {
      api.createRecord('5c5cad8e', component.options)
    } else {
      api.reload('5c5cad8e', component.options)
    }
    module.hot.accept("./HomeCommon.vue?vue&type=template&id=5c5cad8e&scoped=true", function () {
      api.rerender('5c5cad8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/HomeCommon.vue"
export default component.exports